import { combineReducers } from 'redux-immutable'

import carouselReducer from './components/CarouselBanner/reducer'
import lineReducer from './components/LineBanner/reducer'

const rootReducer = combineReducers({
    carousel: carouselReducer,
    line: lineReducer,
})

export default rootReducer
